import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import * as AiIcons from 'react-icons/ai';
import * as BsIcons from 'react-icons/bs';
import {
  MainItemModalView,
  FreebieModalView,
  PrintModalView,
  FreebieInfoModalView,
  ImportModalView,
} from 'components/EventRegistration';
import { Search } from '../components/ChannelRegistration/';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ko from 'date-fns/locale/ko';
import { Button, Checkbox, Spin, Row, Col, Input } from 'antd';
import Swal from 'sweetalert2';
import { getItemGroupsBrand, getEventChannel } from 'http-api';
import { LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import {
  getItemGroups,
  getFreebieData,
  getFreebieErpData,
  getPrintData,
  getEventData,
  getSelectedEventData,
  registEventData,
} from 'http-api';
import { useSelector } from 'react-redux';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

function EventRegistration() {
  const user = useSelector((state) => state.user);
  const [title, setTitle] = useState('');
  const [stepStatus, setStepStatus] = useState(1);
  const [stepOneLoading, setStepOneLoading] = useState(false);

  const [countMainItem, setCountMainItem] = useState(0);
  const [countFreebie, setCountFreebie] = useState(0);
  const [countPrint, setCountPrint] = useState(0);

  const [mainLoading, setMainLoading] = useState(false);
  const [freebieLoading, setFreebieLoading] = useState(false);
  const [printLoading, setPrintLoading] = useState(false);

  const [mainItemModalVisible, setMainItemModalVisible] = useState(false);
  const [freebieModalVisible, setFreebieModalVisible] = useState(false);
  const [printModalVisible, setPrintModalVisible] = useState(false);

  const [mainItems, setMainItems] = useState([]);
  const [freebies, setFreebies] = useState([]);
  const [prints, setPrints] = useState([]);

  const [mainItemsData, setMainItemsData] = useState([]);
  const [freebiesData, setFreebiesData] = useState([]);
  const [freebieErpData, setFreebieErpData] = useState([]);
  const [printsData, setPrintsData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [eventData, setEventData] = useState([]);

  const [minBuyNumber, setMinBuyNumber] = useState(0);
  const [minBuyNumberChecked, setMinBuyNumberChecked] = useState(true);
  const [minBuyPrice, setMinBuyPrice] = useState(0);
  const [minBuyPriceChecked, setMinBuyPriceChecked] = useState(true);
  const [limitNumber, setLimitNumber] = useState(0);
  const [limitNumberChecked, setLimitNumberChecked] = useState(true);

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);
  const [isInfinited, setIsInfinited] = useState(false);
  registerLocale('ko', ko);

  const [freebieRange, setFreebieRange] = useState(true);
  const [freebieType, setFreebieType] = useState('');
  const [freebieInfoModalVisible, setFreebieInfoModalVisible] = useState(false);
  const [rangeNumber, setRangeNumber] = useState(0);

  const [postLoading, setPostLoading] = useState(false);
  const [importLoading, setImportLoading] = useState(false);
  const [importVisible, setImportVisible] = useState(false);

  const [selectedRows, setSelectedRow] = useState();
  const [selectedRowLoading, setSelectedRowLoading] = useState(false);

  const [loading, setLoading] = useState(true);
  const [sabangnetChannels, setSabangnetChannel] = useState();
  const [userInput, setUserInput] = useState('');
  const [searchedSabangnetChannel, setSearchedSabangnetChannel] =
    useState(sabangnetChannels);

  const [checkAll, setCheckAll] = useState(false);

  const handleChange = (e) => {
    const value = e.target.value;
    setUserInput(value);
  };
  const onCheckAllChange = (e) => {
    setSearchedSabangnetChannel(
      searchedSabangnetChannel.map((channel) => {
        return { ...channel, checked: e.target.checked ? true : false };
      })
    );
    setCheckAll(e.target.checked);
  };
  const handleClick = () => {
    setSearchedSabangnetChannel(
      sabangnetChannels.filter((channel) => channel.name.includes(userInput))
    );
  };
  const setSabangnetChannelList = async () => {
    setLoading(true);
    const channelList = await getEventChannel(user.token);
    setSabangnetChannel(channelList);
    setSearchedSabangnetChannel(channelList);
    setLoading(false);
  };
  const onChangeChannel = (id, e) => {
    setSearchedSabangnetChannel(
      searchedSabangnetChannel.map((channel) => {
        if (id === channel.id) {
          return { ...channel, checked: e.target.checked };
        }
        return { ...channel };
      })
    );
  };
  useEffect(() => {
    searchedSabangnetChannel &&
      setCheckAll(
        searchedSabangnetChannel.length ===
          searchedSabangnetChannel.filter((channel) => channel.checked).length
      );
  }, [searchedSabangnetChannel]);
  useEffect(() => {
    if (stepStatus === 4) {
      setSabangnetChannelList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepStatus]);
  const getMainItemData = async () => {
    setMainLoading(true);
    try {
      const res = await getItemGroups(user.token);
      if (res.data.result.length !== 0) {
        setMainItemsData(res.data.result);
        setStepOneLoading(false);
        setMainLoading(false);
        openModal('main');
      } else {
        setMainLoading(false);
      }
    } catch (err) {
      alert('데이터를 불러올 수 없습니다.');
      setMainLoading(false);
    }
  };
  const getFreebieDatas = async () => {
    setFreebieLoading(true);
    try {
      const res = await getFreebieData(user.token);
      if (res.data.result.length !== 0) {
        setFreebiesData(res.data.result);
      } else {
        alert('등록된 ERP미등록 제품이 없습니다.');
      }
    } catch (err) {
      alert('데이터를 불러올 수 없습니다.');
    }
  };
  const getFreebieErpDatas = async () => {
    setFreebieLoading(true);
    try {
      const res = await getFreebieErpData(user.token);
      if (res.data.result.length !== 0) {
        setFreebieErpData(res.data.result);
        openModal('freebie');
        setFreebieLoading(false);
      } else {
        alert('등록된 사은품이 없습니다.');
        setFreebieLoading(false);
      }
    } catch (err) {
      setFreebieLoading(false);
      alert('데이터를 불러올 수 없습니다.');
    }
  };
  const getPrintDatas = async () => {
    setPrintLoading(true);
    try {
      const res = await getPrintData(user.token);
      if (res.data.result.length !== 0) {
        setPrintsData(res.data.result);
        setPrintLoading(false);
        openModal('print');
      } else {
        console.log(res.status);
        alert('등록된 인쇄물이 없습니다.');
        setPrintLoading(false);
      }
    } catch (err) {
      alert('데이터를 불러올 수 없습니다.');
      setPrintLoading(false);
    }
  };
  const getBrandData = async () => {
    const response = await getItemGroupsBrand(user.token);
    setBrandData(response.data.result);
  };
  const getImportData = async () => {
    setImportLoading(true);
    setMainLoading(true);
    try {
      const res = await getEventData();
      if (res.data.result) {
        setEventData(res.data.result);
        setImportLoading(false);
        setMainLoading(false);
        openModal('import');
      } else {
        console.log(res.status);
        setImportLoading(false);
        setMainLoading(false);
        alert('데이터를 등록해주세요');
      }
    } catch (err) {
      setImportLoading(false);
      setMainLoading(false);
      alert('데이터를 불러올 수 없습니다.');
    }
  };
  const getEventDatas = async () => {
    setSelectedRowLoading(true);
    try {
      const res = await getSelectedEventData(selectedRows[0].id);
      if (res.data.result) {
        setSelectedRowLoading(false);

        closeModal('import');
        const data = res.data.result;
        importData(data);
      } else {
        console.log(res.status);
        alert('데이터를 등록해주세요');
        setSelectedRowLoading(false);
        closeModal('import');
      }
    } catch (err) {
      alert('데이터를 불러올 수 없습니다.');
      setSelectedRowLoading(false);
      closeModal('import');
    }
  };

  const onChangeTitle = (e) => {
    setTitle(e.target.value);
  };
  const setNextStep = () => {
    if (stepStatus === 3) {
      if (minBuyNumber < 2 && !minBuyNumberChecked) {
        alert('최소구매개수는 2개 이상이어야 합니다.');
      } else {
        setSabangnetChannelList();
        setStepStatus(stepStatus + 1);
      }
    } else if (stepStatus === 4) {
      if (
        searchedSabangnetChannel.filter((channel) => channel.checked).length !==
        0
      ) {
        postEventData();
      } else {
        Swal.fire({
          text: '하나이상의 채널을 선택해주세요',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } else setStepStatus(stepStatus + 1);
  };
  const setBackStep = () => {
    setStepStatus(stepStatus - 1);
  };
  const openModal = (type) => {
    if (type === 'main') {
      setMainItemModalVisible(true);
    } else if (type === 'freebie') {
      setFreebieModalVisible(true);
    } else if (type === 'print') {
      setPrintModalVisible(true);
    } else if (type === 'freebieInfo') {
      setFreebieInfoModalVisible(true);
    } else if (type === 'import') {
      setImportVisible(true);
    }
  };
  function closeModal(type) {
    if (type === 'main') {
      setMainItemModalVisible(false);
    } else if (type === 'freebie') {
      setFreebieModalVisible(false);
    } else if (type === 'print') {
      setPrintModalVisible(false);
    } else if (type === 'freebieInfo') {
      setFreebieInfoModalVisible(false);
      setRangeNumber(0);
      setFreebieType('');
      setFreebieRange('');
    } else if (type === 'import') {
      setImportVisible(false);
    }
  }
  const reload = (type) => {
    if (type === 'main') {
      setMainItems([]);
    } else if (type === 'freebie') {
      setFreebies([]);
    } else if (type === 'print') {
      setPrints([]);
    }
  };
  const removeItem = (index, type) => {
    if (type === 'main') {
      setMainItems(mainItems.filter((item) => item !== mainItems[index]));
    } else if (type === 'freebie') {
      setFreebies(freebies.filter((item) => item !== freebies[index]));
    } else if (type === 'print') {
      setPrints(prints.filter((item) => item !== prints[index]));
    } else if (type === 'all') {
      setMainItems([]);
    }
  };

  useEffect(() => {
    numberCheck(minBuyNumber);
  }, [minBuyNumber]);

  function onChangeNumber(e, type) {
    numberCheck(e.target.value, type);
  }

  const numberCheck = (v, type) => {
    let num = v || 0;
    if (!isFinite(num)) return;
    num = num.toString();

    if (num !== '0' && !num.includes('.')) {
      num = num.replace(/^0+/, '');
    }

    num = Number(num);

    if (type === 'minBuyNumber') {
      setMinBuyNumber(num);
    } else if (type === 'minBuyPrice') {
      setMinBuyPrice(num);
    } else if (type === 'limitNumber') {
      setLimitNumber(num);
    } else if (type === 'range') {
      setRangeNumber(num);
    }
  };

  useEffect(() => {
    if (isInfinited === true) {
      setEndDate(null);
    }
  }, [isInfinited]);
  const postEventData = async () => {
    setPostLoading(true);
    const eventData = {};

    eventData.title = title;
    eventData.items = mainItems;
    eventData.freebies = freebies;
    eventData.isRange = freebieRange;
    eventData.rangeQuantity = rangeNumber;
    eventData.type = freebieType;
    eventData.prints = prints;
    eventData.minimumQuantity = minBuyNumber;
    eventData.minimumAmount = minBuyPrice;
    eventData.initialLimitedQuantity = limitNumber;
    eventData.startDate = startDate;
    eventData.endDate = endDate;
    eventData.channels = searchedSabangnetChannel.filter(
      (channel) => channel.checked
    );
    const data = {
      groupId: 1,
      data: eventData,
    };
    console.log(data);
    try {
      const res = await registEventData(user.token, data);
      if (res.status === 201) {
        enterLoading();
      } else {
        console.log(res.status);
        alert('데이터를 등록해주세요');
      }
    } catch (err) {
      alert('데이터를 불러올 수 없습니다.');
      setPostLoading(false);
    }
  };
  const enterLoading = () => {
    setPostLoading(false);
    Swal.fire({
      title: '등록 완료',
      icon: 'success',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: '확인',
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  };
  const importData = (data) => {
    getMainItemData();
    getFreebieDatas();
    getPrintDatas();
    getBrandData();
    getFreebieErpDatas();
    setStepStatus(stepStatus + 1);
    setTitle(data.title);
    setMainItems(data.items);
    setFreebies(data.freebies);
    setPrints(data.prints);
  };

  useEffect(() => {
    setCountMainItem(mainItems.length);
  }, [mainItems]);
  useEffect(() => {
    setCountFreebie(freebies.length);
  }, [freebies]);
  useEffect(() => {
    setCountPrint(prints.length);
  }, [prints]);

  return (
    <Container>
      <StepWrapper>
        <VerticalLine />
        <StepOneLabel
          activate={
            stepStatus === 1 ||
            stepStatus === 2 ||
            stepStatus === 3 ||
            stepStatus === 4
          }
        >
          {stepStatus > 1 ? '✔' : '1'}
        </StepOneLabel>
        <br />
        <StepTwoLabel
          activate={stepStatus === 2 || stepStatus === 3 || stepStatus === 4}
        >
          {stepStatus > 2 ? '✔' : '2'}
        </StepTwoLabel>
        <br />
        <StepThreeLabel activate={stepStatus === 3 || stepStatus === 4}>
          {stepStatus > 3 ? '✔' : '3'}
        </StepThreeLabel>
        <br />
        <StepFourLabel activate={stepStatus === 4}>
          {stepStatus > 4 ? '✔' : '4'}
        </StepFourLabel>
      </StepWrapper>
      <Wrapper>
        <EventInfomationWrapper visible={stepStatus > 2}>
          <EventInfomation>
            <EventInfomationText>이벤트명</EventInfomationText>
            {title && title}
          </EventInfomation>
          <EventInfomation>
            <EventInfomationText>본품</EventInfomationText>
            {mainItems.length !== brandData.length
              ? mainItems.map((item) => item.name).join(', ')
              : '전체 브랜드'}
          </EventInfomation>
          <EventInfomation>
            <EventInfomationText>사은품</EventInfomationText>
            {freebies.length !== 0
              ? freebies.map((item) => item.name).join(', ')
              : '-'}
          </EventInfomation>
          <EventInfomation>
            <EventInfomationText>인쇄물</EventInfomationText>
            {prints.length !== 0
              ? prints.map((item) => item.name).join(', ')
              : '-'}
          </EventInfomation>
        </EventInfomationWrapper>
        {stepStatus === 1 && (
          <>
            <SubTitle>이벤트 이름을 입력해주세요</SubTitle>
            <ImportButton
              onClick={() => getImportData()}
              loading={importLoading}
            >
              불러오기
            </ImportButton>
            {importVisible && (
              <ImportModalView
                close={() => closeModal('import')}
                eventData={eventData}
                loading={importLoading}
                importData={importData}
                setSelectedRow={setSelectedRow}
                getEventData={getEventDatas}
                selectedRowLoading={selectedRowLoading}
              />
            )}
            <br />
            <Description>
              이미 등록된 이벤트 정보를 수정하고 싶다면 우측 상단의 '불러오기'를
              클릭하세요
            </Description>
            <InputText
              type="text"
              onChange={(e) => {
                onChangeTitle(e);
              }}
              value={title}
              placeholder="ex) 어린이날 행사 이벤트"
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  setNextStep();
                }
              }}
            />
            <StepButtonWrapper>
              <StepNextButton
                onClick={setNextStep}
                disabled={!title}
                loading={stepOneLoading}
              >
                {stepOneLoading ? '' : '다음'}
              </StepNextButton>
            </StepButtonWrapper>
          </>
        )}
        {stepStatus === 2 && (
          <>
            <ContentWrapper>
              <LabelWrapper>
                <TextLabel>본품</TextLabel>
                <CountLabel>{countMainItem}</CountLabel>
                <ReloadButton onClick={() => reload('main')}>
                  <AiIcons.AiOutlineReload size="24" color="#7f7f7f" />
                </ReloadButton>
              </LabelWrapper>
              <ItemWrapper>
                {brandData.length !== mainItems.length &&
                  mainItems &&
                  mainItems.map((item, index) => (
                    <Item key={index}>
                      {item.image && <ItemImage src={item.image} />}
                      {item.label ?? item.name}
                      <TrashIcon onClick={() => removeItem(index, 'main')} />
                    </Item>
                  ))}
                {mainItems.length !== 0 &&
                  brandData.length === mainItems.length && (
                    <Item>
                      전체 브랜드
                      <TrashIcon onClick={() => removeItem(1, 'all')} />
                    </Item>
                  )}
                <AddItem
                  onClick={() => {
                    getMainItemData();
                    getBrandData();
                  }}
                >
                  {mainLoading ? (
                    <Spin indicator={antIcon} />
                  ) : (
                    '+ 아이템 추가하기'
                  )}
                </AddItem>
              </ItemWrapper>
              {mainItemModalVisible && (
                <MainItemModalView
                  close={() => {
                    closeModal('main');
                  }}
                  setMainItems={setMainItems}
                  mainItemsData={mainItemsData}
                  brandData={brandData}
                />
              )}
            </ContentWrapper>
            <ParticionLine />
            <ContentWrapper>
              <LabelWrapper>
                <TextLabel>사은품</TextLabel>
                <CountLabel>{countFreebie}</CountLabel>
                <FreebieInfoButton
                  disabled={freebies.length === 0}
                  onClick={() => openModal('freebieInfo')}
                >
                  사은품 정보
                </FreebieInfoButton>
                {freebieInfoModalVisible && (
                  <FreebieInfoModalView
                    close={() => closeModal('freebieInfo')}
                    onChangeNumber={onChangeNumber}
                    rangeNumber={rangeNumber}
                    setRangeNumber={setRangeNumber}
                    freebieRange={freebieRange}
                    freebieType={freebieType}
                    setFreebieRange={setFreebieRange}
                    setFreebieType={setFreebieType}
                    setFreebieInfoModalVisible={setFreebieInfoModalVisible}
                  />
                )}
                <ReloadButton onClick={() => reload('freebie')}>
                  <AiIcons.AiOutlineReload size="24" color="#7f7f7f" />
                </ReloadButton>
              </LabelWrapper>
              <ItemWrapper>
                {freebies &&
                  freebies.map((item, index) => (
                    <Item key={index}>
                      {item.image && <ItemImage src={item.image} />}
                      {item.name}
                      <TrashIcon onClick={() => removeItem(index, 'freebie')} />
                    </Item>
                  ))}
                <AddItem
                  onClick={() => {
                    getFreebieDatas();
                    getFreebieErpDatas();
                  }}
                >
                  {freebieLoading ? (
                    <Spin indicator={antIcon} />
                  ) : (
                    '+ 아이템 추가하기'
                  )}
                </AddItem>
              </ItemWrapper>
              {freebieModalVisible && (
                <FreebieModalView
                  close={() => {
                    closeModal('freebie');
                  }}
                  setFreebies={setFreebies}
                  erpData={freebieErpData}
                  freebiesData={freebiesData}
                  brandData={brandData}
                />
              )}
            </ContentWrapper>
            <ContentWrapper>
              <LabelWrapper>
                <TextLabel>인쇄물</TextLabel>
                <CountLabel>{countPrint}</CountLabel>
                <ReloadButton onClick={() => reload('print')}>
                  <AiIcons.AiOutlineReload size="24" color="#7f7f7f" />
                </ReloadButton>
              </LabelWrapper>
              <ItemWrapper>
                {prints &&
                  prints.map((item, index) => (
                    <Item key={index}>
                      {item.image && <ItemImage src={item.image} />}
                      {item.name}
                      <TrashIcon onClick={() => removeItem(index, 'print')} />
                    </Item>
                  ))}
                <AddItem
                  onClick={() => {
                    getPrintDatas();
                  }}
                >
                  {printLoading ? (
                    <Spin indicator={antIcon} />
                  ) : (
                    '+ 아이템 추가하기'
                  )}
                </AddItem>
              </ItemWrapper>
              {printModalVisible && (
                <PrintModalView
                  close={() => {
                    closeModal('print');
                  }}
                  setPrints={setPrints}
                  printsData={printsData}
                  brandData={brandData}
                />
              )}
            </ContentWrapper>
            <StepButtonWrapper>
              <StepBackButton onClick={setBackStep}>이전</StepBackButton>
              <StepNextButton
                onClick={setNextStep}
                disabled={
                  !(
                    mainItems.length !== 0 &&
                    (freebies.length !== 0 || prints.length !== 0)
                  )
                }
              >
                다음
              </StepNextButton>
            </StepButtonWrapper>
          </>
        )}
        {stepStatus === 3 && (
          <>
            <SubTitle>이벤트 방식</SubTitle>
            <EventWayList>
              <Way>
                <WayText>최소구매개수</WayText>
                <InputNumber
                  type="text"
                  value={minBuyNumber || 0}
                  onChange={(e) => {
                    onChangeNumber(e, 'minBuyNumber');
                  }}
                  disabled={minBuyNumberChecked}
                />
                개
                <WayOption className="checkbox">
                  <ACheckbox
                    value={minBuyNumberChecked}
                    checked={minBuyNumberChecked}
                    onChange={() => {
                      setMinBuyNumber(0);
                      setMinBuyNumberChecked(!minBuyNumberChecked);
                    }}
                  >
                    해당없음
                  </ACheckbox>
                </WayOption>
                <WayOption className="placeholder">
                  2개 이상부터 입력해주세요
                </WayOption>
              </Way>
              <Way>
                <WayText>최소구매금액</WayText>
                <InputNumber
                  type="text"
                  value={minBuyPrice || 0}
                  onChange={(e) => {
                    onChangeNumber(e, 'minBuyPrice');
                  }}
                  disabled={minBuyPriceChecked}
                />
                원
                <WayOption className="checkbox">
                  <ACheckbox
                    value={minBuyPriceChecked}
                    checked={minBuyPriceChecked}
                    onChange={() => {
                      setMinBuyPrice(0);
                      setMinBuyPriceChecked(!minBuyPriceChecked);
                    }}
                  >
                    해당없음
                  </ACheckbox>
                </WayOption>
              </Way>
              {freebies.length !== 0 && (
                <Way>
                  <WayText>한정수량</WayText>
                  <InputNumber
                    type="text"
                    value={limitNumber || 0}
                    onChange={(e) => {
                      onChangeNumber(e, 'limitNumber');
                    }}
                    disabled={limitNumberChecked}
                  />
                  개
                  <WayOption className="checkbox">
                    <ACheckbox
                      value={limitNumberChecked}
                      checked={limitNumberChecked}
                      onChange={() => {
                        setLimitNumber(0);
                        setLimitNumberChecked(!limitNumberChecked);
                      }}
                    >
                      제한없음
                    </ACheckbox>
                  </WayOption>
                </Way>
              )}
            </EventWayList>
            <SubTitle>증정 기간</SubTitle>
            <br />
            <Description>
              설정된 날짜부터 사은품 또는 인쇄물이 제공됩니다.
            </Description>
            <CalenderWrapper>
              <Calender
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                dateFormat={'yyyy. MM. dd'}
                locale={ko}
              />
              ~
              <Calender
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                dateFormat={'yyyy. MM. dd'}
                locale={ko}
                disabled={isInfinited}
              />
              <WayOption className="checkbox">
                <ACheckbox
                  value={isInfinited}
                  checked={isInfinited}
                  onChange={() => setIsInfinited(!isInfinited)}
                >
                  제한없음
                </ACheckbox>
              </WayOption>
            </CalenderWrapper>
            <StepButtonWrapper>
              <StepBackButton onClick={setBackStep}>이전</StepBackButton>
              <StepNextButton
                onClick={setNextStep}
                disabled={
                  !(
                    (minBuyNumber || minBuyNumberChecked) &&
                    (minBuyPrice || minBuyPriceChecked) &&
                    (limitNumber || limitNumberChecked) &&
                    (endDate || isInfinited)
                  )
                }
              >
                다음
              </StepNextButton>
            </StepButtonWrapper>
          </>
        )}
        {stepStatus === 4 && (
          <>
            <SubTitle>
              이벤트를 진행할 채널을 선택해주세요 (복수선택 가능)
            </SubTitle>
            <br />
            <ChannelWrapper>
              <LeftContent>
                <SubTitle>판매 채널</SubTitle>
                <AllCheckboxWrapper>
                  <ACheckbox onChange={onCheckAllChange} checked={checkAll}>
                    전체 선택 / 해제
                  </ACheckbox>
                </AllCheckboxWrapper>
                <Search
                  handleChange={handleChange}
                  handleClick={() => handleClick()}
                />
                <ChannelListWrapper loading={loading.toString()}>
                  {loading ? (
                    <Spinner size="large" tip="데이터를 불러오는 중입니다..." />
                  ) : (
                    <Row>
                      {searchedSabangnetChannel.length !== 0 ? (
                        searchedSabangnetChannel.map((channel) => (
                          <Col
                            key={channel.id}
                            span={8}
                            style={{ marginBottom: '10px' }}
                          >
                            <ACheckbox
                              onChange={(e) => onChangeChannel(channel.id, e)}
                              value={channel}
                              checked={channel.checked}
                            >
                              {channel.name}
                            </ACheckbox>
                          </Col>
                        ))
                      ) : (
                        <Description>
                          매핑된 채널이 없습니다.
                          <Link to="/">불러오기</Link>
                        </Description>
                      )}
                    </Row>
                  )}
                </ChannelListWrapper>
                <Line />
                <StepButtonWrapper>
                  <StepBackButton onClick={setBackStep}>이전</StepBackButton>
                  <StepNextButton
                    type="primary"
                    onClick={setNextStep}
                    loading={postLoading}
                  >
                    {postLoading ? '' : '완료'}
                  </StepNextButton>
                </StepButtonWrapper>
              </LeftContent>
            </ChannelWrapper>
          </>
        )}
      </Wrapper>
    </Container>
  );
}

const Container = styled.div`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 56px);
  text-align: center;
  /* z-index: -1; */
`;
const StepWrapper = styled.div`
  position: absolute;
  top: 80px;
  left: 200px;
  width: 100px;
  height: 400px;
  text-align: center;
`;
const StepOneLabel = styled.div`
  position: relative;
  display: inline-block;
  width: 30px;
  height: 30px;
  border-radius: 30px;
  line-height: 30px;
  background-color: ${(props) => (props.activate ? '#0077d7' : '#d9d9d9')};
  color: #fff;
  text-align: center;
  margin-bottom: 60px;
`;
const StepTwoLabel = styled.div`
  position: relative;
  display: inline-block;
  width: 30px;
  height: 30px;
  border-radius: 30px;
  line-height: 30px;
  background-color: ${(props) => (props.activate ? '#0077d7' : '#d9d9d9')};
  color: #fff;
  text-align: center;
  margin-bottom: 60px;
`;
const StepThreeLabel = styled.div`
  position: relative;
  display: inline-block;
  width: 30px;
  height: 30px;
  border-radius: 30px;
  line-height: 30px;
  background-color: ${(props) => (props.activate ? '#0077d7' : '#d9d9d9')};
  color: #fff;
  text-align: center;
  margin-bottom: 60px;
`;
const StepFourLabel = styled.div`
  position: relative;
  display: inline-block;
  width: 30px;
  height: 30px;
  border-radius: 30px;
  line-height: 30px;
  background-color: ${(props) => (props.activate ? '#0077d7' : '#d9d9d9')};
  color: #fff;
  text-align: center;
  margin-bottom: 60px;
`;
const VerticalLine = styled.div`
  position: absolute;
  left: 50px;
  width: 1px;
  height: 300px;
  background-color: ${(props) => props.theme.colors.darkGray};
`;
const Wrapper = styled.div`
  position: relative;
  top: 100px;
  display: inline-block;
  width: 60%;
  text-align: start;
  padding-bottom: 40px;
`;
const SubTitle = styled.h2`
  position: relative;
  display: inline-block;
`;
const Description = styled.div`
  position: relative;
  display: inline-block;
  color: ${(props) => props.theme.colors.darkGray};
`;
const InputText = styled.input`
  all: unset;
  margin-top: 40px;
  position: relative;
  display: block;
  width: 80%;
  border-bottom: 1px solid ${(props) => props.theme.colors.darkGray};
  padding: 10px 5px;
  font-size: 1rem;
  font-weight: bold;
`;
const StepButtonWrapper = styled.div`
  float: right;
  margin-top: 80px;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
  transition: 0.2s all;
`;
const StepNextButton = styled(Button)`
  all: unset;
  width: 40px;
  color: #fff;
  border: 1px solid ${(props) => props.theme.colors.gray};
  background-color: ${(props) => (props.disabled ? '#d9d9d9' : '#0077d7')};
  padding: 0.5rem 2rem;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  border-radius: 2px;
  &:hover {
    background-color: ${(props) => props.theme.colors.blue};
    color: #fff;
  }
`;
const StepBackButton = styled(Button)`
  all: unset;
  margin-right: 20px;
  width: 40px;
  border: 1px solid ${(props) => props.theme.colors.darkGray};
  color: #000;
  background-color: #fff;
  padding: 0.5rem 2rem;
  cursor: pointer;
  border-radius: 2px;
`;
const ContentWrapper = styled.div`
  position: relative;
  display: inline-block;
  margin-left: 2%;
  min-width: 30%;
  height: 500px;
  background-color: #eff3ff;
  border-radius: 20px;
  vertical-align: top;
`;
const ParticionLine = styled.div`
  display: inline-block;
  margin-left: 20px;
  border-left: 2px dashed #7f7f7f;
  height: 500px;
  width: 1px;
`;
const LabelWrapper = styled.div`
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
`;
const TextLabel = styled.div`
  position: relative;
  display: inline-block;
  font-size: 1.2rem;
  font-weight: 800;
`;
const CountLabel = styled.div`
  position: relative;
  display: inline-block;
  margin-left: 10px;
  width: 25px;
  height: 25px;
  line-height: 25px;
  background-color: #eee;
  color: #7f7f7f;
  text-align: center;
  border-radius: 3px;
`;
const ItemWrapper = styled.ul`
  margin-top: 20px;
  position: relative;
  margin: 0 auto;
  width: 90%;
  text-align: center;
  list-style: none;
`;
const AddItem = styled.li`
  width: 100%;
  height: 60px;
  line-height: 60px;
  border-radius: 5px;
  background-color: #c6d3ff;
  color: #7f7f7f;
  font-weight: bold;
  margin-bottom: 10px;
  cursor: pointer;
`;
const Item = styled.li`
  width: 100%;
  height: 60px;
  /* line-height: 40px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
  background-color: #fff;
  color: #000;
  margin-bottom: 10px;
  border: 1px solid #f3f3f3;
  border-radius: 5px;
  box-shadow: rgb(235 235 235) 3px 3px 5px;
  font-weight: bold;
  text-align: center;
  padding: 10px;
`;
const ReloadButton = styled.div`
  position: relative;
  float: right;
  cursor: pointer;
`;

const EventWayList = styled.ul`
  margin: 30px 0 100px;
  list-style: none;
`;
const Way = styled.li`
  margin-bottom: 15px;
  padding-left: 15px;
  font-size: 15px;
  font-weight: bold;
`;
const WayText = styled.div`
  position: relative;
  display: inline-block;
  width: 150px;
`;
const InputNumber = styled(Input)`
  all: unset;
  position: relative;
  display: inline-block;
  margin: 0 10px 0 40px;
  width: 120px;
  background-color: ${(props) => props.theme.colors.lightGray};
  height: 1rem;
  padding: 10px 5px;
  font-size: 1rem;
  font-weight: bold;
  text-align: right;
`;
const WayOption = styled.div`
  position: relative;
  display: inline-block;
  margin-left: 20px;
  &.placeholder {
    color: ${(props) => props.theme.colors.darkGray};
    font-size: 14px;
    font-weight: normal;
  }
  div.react-datepicker-wrapper {
    width: 10%;
  }
`;
const CalenderWrapper = styled.div`
  position: relative;
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  .react-datepicker-wrapper {
    margin: 0 15px;
    display: inline-block;
  }
`;
const Calender = styled(DatePicker)`
  all: unset;
  padding: 5px 10px;
  border: 1px solid ${(props) => props.theme.colors.gray};
`;
const EventInfomationWrapper = styled.ul`
  position: absolute;
  display: ${(props) => (props.visible ? 'block' : 'none')};
  top: -40px;
  left: 50vw;
  width: 25vw;
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.colors.darkGray};
  list-style: none;
  padding: 20px;
  box-shadow: rgb(235 235 235) 3px 3px 5px;
`;
const EventInfomation = styled.li`
  padding: 5px 0;
  font-size: 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
const EventInfomationText = styled.div`
  position: relative;
  display: inline-block;
  width: 100px;
  font-weight: bold;
`;
const ItemImage = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 36px;
`;
const FreebieInfoButton = styled.button`
  margin-left: 20px;
  padding: 1px 5px;
  color: #fff;
  background-color: ${(props) => (props.disabled ? '#7f7f7f' : '#0077d7')};
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  border: ${(props) =>
    props.disabled ? '1px solid #7f7f7f' : '1px solid #0077d7'};
  box-sizing: border-box;
  border-radius: 5px;
`;
const ImportButton = styled(Button)`
  float: right;
  display: flex;
  padding: 1.2rem 1.7rem;
  align-items: center;
`;
const TrashIcon = styled(BsIcons.BsTrash)`
  color: ${(props) => props.theme.colors.darkGray};
  cursor: pointer;
  &:hover {
    color: black;
  }
`;
const ChannelWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  height: 600px;
`;
const LeftContent = styled.div`
  border: 1px solid ${(props) => props.theme.colors.darkGray};
  border-radius: 15px;
  flex: 0.6;
  margin-right: 20px;
  padding: 20px;
`;
const Line = styled.div`
  width: calc(100% + 40px);
  margin-left: -20px;
  border-bottom: 1px solid ${(props) => props.theme.colors.darkGray};
`;
const ChannelListWrapper = styled.div`
  margin: 20px 0;
  border: 1px solid ${(props) => props.theme.colors.darkGray};
  border-radius: 5px;
  height: 50%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: ${(props) =>
    props.loading === 'true' ? 'center' : 'flex-start'};
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.colors.darkGray};
    border-radius: 5px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 5px;
    box-shadow: inset 0px 0px 5px white;
  }
`;
const AllCheckboxWrapper = styled.div`
  float: right;
  color: ${(props) => props.theme.colors.darkGray};
`;
const ACheckbox = styled(Checkbox)`
  font-size: 14px;
  font-weight: normal;
  .ant-checkbox + span {
    color: ${(props) => props.theme.colors.darkGray};
  }
`;
const Spinner = styled(Spin)`
  margin-top: 10px;
`;
export default EventRegistration;
